export const notNull = <T>(x: T | null | undefined): x is T => x !== undefined && x !== null;

export const notFalsy = <T>(x: T | null | undefined | false | 0 | ""): x is T => !!x;

export const notEmpty = (x: string | null | undefined): x is string => !!x?.trim();
